<template>
  <div class="pdf-viewer-template">
    <div id="adobe-dc-view"></div>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";

export default {
  name: "PDFViewer",
  mounted() {
    setTimeout(() => {
      this.loadPdf();
    }, 1000);
  },
  props: {
    src: {
      required: true,
      type: String
    }
  },
  methods: {
    loadPdf() {
      var adobeDCView = new AdobeDC.View({
        clientId:
          VueCookie.get("os_type") === "ios"
            ? process.env.VUE_APP_ADOBE_VIEW_LOCALHOST_CLIENT_ID
            : process.env.VUE_APP_ADOBE_VIEW_CLIENT_ID,
        divId: "adobe-dc-view"
      });
      adobeDCView.previewFile(
        {
          content: {
            location: {
              url: this.src
            }
          },
          metaData: {
            fileName: "Sharpen resource"
          }
        },
        {
          defaultViewMode: "FIT_WIDTH",
          showAnnotationTools: false,
          showDownloadPDF: false
        }
      );
    }
  }
};
</script>

<style lang="scss">
#adobe-dc-view {
  min-height: calc(100vh - 144px);
  iframe {
    min-height: calc(100vh - 144px);
  }
}
</style>